import React from 'react';
import useAppSelector, { useAppDispatch } from '../app/redux/useAppSelector';
import Button from '../components/Button';
import Form, { Field } from '../components/Form';
import Modal from '../components/Modal';
import { ACTION_REFERRAL_COPY, CATEGORY_GROWTH } from '../constants/analytics';
import { miscToasts } from '../toasts/toasts';
import { UIActions } from '../ui/uiSlice';
import { track } from '../utils/analytics';
import Link from '../utils/router/Link';
import * as styles from './ReferralModal.module.scss';

interface ReferralModalProps {
  close: () => void;
}

const ReferralModal = ({ close }: ReferralModalProps) => {
  const user = useAppSelector((state) => state.session.user);
  const dispatch = useAppDispatch();

  const link = `slab.com/r/${user.id}`;

  const onClick = async () => {
    track(ACTION_REFERRAL_COPY, { category: CATEGORY_GROWTH });
    await navigator.clipboard.writeText(`https://${link}`);
    dispatch(UIActions.pushToast(miscToasts.shareableLinkCopied));
  };

  return (
    <Modal
      variant="expanded"
      title="Get up to $200 for every friend you refer to Slab!"
      description={
        <>
          Share the link below and get up to $200 in Amazon gift cards per
          referral! Your friend will also get 20% off their first 3 months.{' '}
          <Link to="https://go.slab.com/referral-program" newTab>
            Learn more
          </Link>
        </>
      }
      close={close}
      width={550}
    >
      <Form initialValues={{ link }}>
        <div className={styles.field}>
          <Field margin="none" name="link" readOnly label="Shareable link" />
          <Button variant="primary" onClick={onClick}>
            Copy
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default ReferralModal;
